<template>
  <section class="vas-subscription-form d-flex flex-column h-100 justify-content-around px-3 mt-xxs-4 mt-sm-0">
    <header class="d-sm-block d-xxs-none">
      <h5 class="text-success">
        {{ $t('security.vasSubscription.loginTitle') }}
      </h5>
    </header>

    <section class="phone-input d-flex flex-column">
      <PhoneNumberInput ref="phoneNumberInput" :phone-number-input-text="PhoneNumberInputText" />
      <b-button
        variant="primary"
        size="lg"
        class="w-100"
        @click="checkPhoneNumber"
      >
        {{ $t('security.loginButtonText') }}
      </b-button>
    </section>
    <footer class="footer d-flex flex-column">
      <small class="mb-sm-3 mb-xxs-4 mt-sm-0 mt-xxs-3">
        {{ designConfig.pages.vasLogin.configurations.footerText }}
      </small>
      <div class="d-flex flex-sm-column flex-xxs-row justify-content-around">
        <b-link
          class="text-danger align-self-start mb-sm-3 mb-xxs-0 text-decoration-none"
          :to="{name:'terms'}"
          target="_blank"
        >
          <small>{{ $t('security.termsAndConditions') }}</small>
        </b-link>
        <div class="line d-sm-block d-xxs-none" />
        <b-link
          :to="{name:'profile'}"
          class="align-self-end mt-sm-4 mt-xxs-0 mb-sm-2 mb-xxs-0 text-decoration-none"
        >
          {{ $t('security.vasSubscription.backToProfile') }}
        </b-link>
      </div>
    </footer>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import utility from '@/utilities/utility'
import PhoneNumberInput from '@/components/PhoneNumberInput.vue'

export default {
  name: 'VasSubscriptionForm',
  components: {
    PhoneNumberInput
  },
  data () {
    return {
      userUniqueIdentifier: '',
      PhoneNumberInputText: 'security.vasSubscription.phoneNumberInputText'
    }
  },
  computed: {
    ...mapGetters({
      designConfig: 'tenantDesign/config'
    }),
    phoneNumberInput () {
      return this.$refs.phoneNumberInput
    },
    phoneNumber () {
      return this.phoneNumberInput.phoneNumber
    }
  },
  created () {
    this.getUserState().then(response => {
      let result = response.body.result

      // TODO: check whether user is subscribed or not
      let userPlans = result.filter(r => r.planType === 'Daily')
      if (userPlans.length > 0) {
        this.$router.push({
          name: 'profile'
        })
      }
    })
  },
  methods: {
    ...mapActions({
      setRouteName: 'order/setRouteName',
      getUserState: 'subscription/getUserState',
      request: 'subscription/requestForSubscription',
      initSub: 'subscription/init'
    }),
    checkPhoneNumber () {
      if (this.phoneNumber.length < 10) {
        this.phoneNumberInput.showInputError()
        return
      }
      this.checkUserStatus()
    },
    checkUserStatus () {
      let payload = {
        userName: this.phoneNumber
      }
      this.getUserState().then(response => {
        let result = response.body.result

        // TODO: check whether user is subscribed or not
        let userPlans = result.filter(r => r.planType === 'Free')
        if (userPlans.length > 0) {
          this.processUnsubscribedUser()
        }
      })
    },
    processUnsubscribedUser () {
      let payload = {
        planProviderCode: this.designConfig.userManagement.vas.planProviderCode,
        pageCode: '',
        channel: 'Portal',
        channelName: window.location.hostname
      }
      this.request(payload).then(response => {
        let result = response.body.result
        this.requestResult = result

        // TODO: Remove country code from payload
        if (result.subscriptionMethod === 'Otp') {
          let initPayload = {
            code: result.code,
            deviceType: 'None',
            userName: this.phoneNumber,
            isEmail: false
          }

          this.initSub(initPayload).then(initResponse => {
            if (initResponse !== undefined) {
              if (initResponse.body.success === false) {
                if (initResponse.body.error.errorCode === 1001) {
                  this.$bvToast.toast(this.$t('landing.AlreadySubscribed'), {
                    title: this.$t('UserProfile.Subscription.BuySubscriptionFactor.warning'),
                    autoHideDelay: 40000,
                    appendToast: true,
                    variant: 'danger',
                    solid: true
                  })
                  return
                }
              }
            }
            this.setRouteName('vasSubscription')
            this.$router.push({
              name: 'sendOtpActivation'
            })
          })
        }
      })
    }
  }
}
</script>
